import { InjectionToken } from '@angular/core';

import { DoodOrderModel } from '@store/order/order.model';

/** Runtime VM emitted by `KioskOrderStatusBlock` data sources. */
export type KioskOrderStatusBlockViewModel = {
  order: DoodOrderModel | undefined;
  orderReadyAt: string;
  receiptPrinted: boolean;
};

export const KIOSK_ORDER_STATUS_BLOCK_LOADING_VM: KioskOrderStatusBlockViewModel = {
  order: undefined,
  orderReadyAt: '',
  receiptPrinted: false,
};

export interface KioskOrderStatusBlockDataSource {
  readonly vm$: import('rxjs').Observable<KioskOrderStatusBlockViewModel>;
}

export const KIOSK_ORDER_STATUS_BLOCK_DATA_SOURCE =
  new InjectionToken<KioskOrderStatusBlockDataSource>('KIOSK_ORDER_STATUS_BLOCK_DATA_SOURCE');
